<template>
    <div class="manage-client-documents mb-5">
        <h3>Client Documents</h3>
        <div class="row">
            <documents :client="client" :is-manage-mode="true"></documents>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ManageClientDocuments',
    components: {

    },
    props: {
        client: {
            type: Object,
            required: true
        }
    },
    data() {
        return {

        };
    },
    methods: {
    }
});
</script>